import * as Sentry from '@sentry/react';

type Integration = Extract<
  NonNullable<Parameters<typeof Sentry.init>[0]['integrations']>,
  unknown[]
>[number];
type SentryWithFeedback = typeof Sentry & {
  feedbackIntegration?: (options: Record<string, unknown>) => Integration;
};

const sentryWithFeedback = Sentry as SentryWithFeedback;

const dsn = import.meta.env.VITE_SENTRY_DSN;
let isSentryInitialized = false;

export const initSentryWithFeedback = (): void => {
  if (isSentryInitialized) return;

  if (!dsn) {
    console.warn('Sentry DSN is not defined');
    return;
  }

  const feedbackIntegration =
    typeof sentryWithFeedback.feedbackIntegration === 'function'
      ? sentryWithFeedback.feedbackIntegration({
          autoInject: false,
          // Keep default Sentry light theme.
          // Dark mode is handled via CSS overrides.
          colorScheme: 'light',
        })
      : undefined;

  Sentry.init({
    dsn,
    sendDefaultPii: true,
    integrations: feedbackIntegration ? [feedbackIntegration] : undefined,
  });

  isSentryInitialized = true;
};
